import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// عميل عام (بدون توكن) — للنقاط العامة
export const publicApi = axios.create({ baseURL: API_BASE });

// عميل الأدمن — يستخدم Cookies (Google session) مع fallback على Bearer JWT القديم
export const adminApi = axios.create({ baseURL: API_BASE, withCredentials: true });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("rush_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// عند 401، نمسح التوكن
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("rush_admin_token");
    }
    return Promise.reject(err);
  }
);

/**
 * تحويل أي شكل detail قادم من FastAPI (string / list of {msg} / dict) إلى نص واحد.
 */
export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "حدث خطأ غير متوقع.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
